// PO1-3480: a Nova Cotação lista o catálogo inteiro de tipos de veículo, com
// os que têm tabela de frete ativa do embarcador primeiro. Os outros podem ser
// escolhidos, mas não têm frete simulado: a cotação segue por Frete Spot ou
// leilão.

export const GRUPO_COM_TABELA = "Com tabela de frete";
export const GRUPO_SEM_TABELA = "Sem tabela (sem frete simulado)";

const opcao = (item, semTabela) => {
  const id = item && (item.id != null ? item.id : item.Id);
  const nome = item && (item.nome != null ? item.nome : item.Nome);
  if (id == null) return null;
  return { value: id, label: nome != null ? String(nome) : String(id), semTabela };
};

const unicos = (lista) => {
  const vistos = new Set();
  return lista.filter((o) => {
    if (!o || vistos.has(String(o.value))) return false;
    vistos.add(String(o.value));
    return true;
  });
};

const porNome = (a, b) => a.label.localeCompare(b.label, "pt-BR");

// ativos = tipos com tabela ativa do embarcador; catalogo = todos os ativos.
// Devolve opções em grupos para o react-select. Sem catálogo, volta a lista
// simples dos que têm tabela (comportamento anterior).
export function montarOpcoesTiposVeiculo(ativos, catalogo) {
  const comTabela = unicos((ativos || []).map((i) => opcao(i, false))).sort(porNome);
  if (!catalogo || !catalogo.length) return comTabela;
  const idsComTabela = new Set(comTabela.map((o) => String(o.value)));
  const semTabela = unicos((catalogo || []).map((i) => opcao(i, true)))
    .filter((o) => !idsComTabela.has(String(o.value)))
    .sort(porNome);
  const grupos = [];
  if (comTabela.length) grupos.push({ label: GRUPO_COM_TABELA, options: comTabela });
  if (semTabela.length) grupos.push({ label: GRUPO_SEM_TABELA, options: semTabela });
  return grupos;
}

// Lista simples (achata os grupos), para procurar a opção pelo id.
export function opcoesPlanas(opcoes) {
  return (opcoes || []).reduce((acc, o) => acc.concat(o && Array.isArray(o.options) ? o.options : [o]), []);
}
